module.exports = __webpack_public_path__ + "static/media/cardIllustrationGreen.788dafc6.svg";